enum AccessLevel {
  READ = 'Read only',
  WRITE = 'Write access',
  FULL_ACCESS = 'Full',
  NO_ACCESS = 'No access',
}

enum AccessLevelIconColor {
  READ = 'bg-warning-500',
  WRITE = 'bg-secondary-unique-200',
  FULL_ACCESS = 'bg-primary-500',
  NO_ACCESS = 'bg-error-500',
}

export { AccessLevel, AccessLevelIconColor };
